import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Sidebar from "../../../Sidebar/Sidebar";
import { useBorrowerContext } from "../BorrowerDetails/store/borrower-details";
import { url } from "../../../App";
import Cookies from "js-cookie";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ToastContainer, toast } from "react-toastify";

const BorrowerDetailsScreen = () => {
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const navigate = useNavigate();
  const { borrowerData, fetchData } = useBorrowerContext();
  const borrower = borrowerData.borrower;
  const loanData = borrowerData.loan;
  const coapplicantDetails = borrowerData.coapplicant;
  const [ImageBase64, setImageBase64] = useState("");
  const [infoData, setInfoData] = useState("");
  const [decryptButtonVisible, setDecryptButtonVisible] = useState(false);
  const [EditButtonVisible, setEditButtonVisible] = useState(false);
  const [AddDocVisible, setAddDocVisible] = useState(false);
  const [ViewDocVisible, setViewDocVisible] = useState(false);
  const [DownloadDocVisible, setDownloadDocVisible] = useState(false);
  const [AddLoanVisible, setAddLoanVisible] = useState(false);
  const [visible, setvisible] = useState(false);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          // console.log(res);
          setDecryptButtonVisible(res.data[0]?.permission?.decrypt_aadhaar);
          setEditButtonVisible(res.data[0]?.permission?.edit_borrower);
          setAddDocVisible(res.data[0]?.permission?.add_borrower_document);
          setViewDocVisible(res.data[0]?.permission?.view_borrower_document);
          setDownloadDocVisible(res.data[0]?.permission?.download_borrower_document);
          setAddLoanVisible(res.data[0]?.permission?.add_loan);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        })
    };
  }, [token, email]);

  useEffect(() => {
    const fetchSelfie = async () => {
      try {
        if (borrower?.borrower_selfphoto) {
          setOpen(true);
          const { doc_name: finalDocName, doc_type: finalDocType } =
            borrower.borrower_selfphoto;

          const req = {
            borrower_uniqueno: id,
            doc_name: finalDocName,
            doc_type: finalDocType,
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
          };

          const res = await axios.post(`${url}/borrower/viewdoc`, req);
          setOpen(false);

          if (res.data.auth && res.data.doc_base64) {
            const mimeType =
              finalDocType === "png"
                ? "image/png"
                : finalDocType === "jpg" || finalDocType === "jpeg"
                  ? "image/jpeg"
                  : "image/*";

            setImageBase64(`data:${mimeType};base64,${res.data.doc_base64}`);
          }
        }
      } catch (err) {
        setOpen(false);
      }
    };

    fetchSelfie();
  }, [borrower, id, loanData, coapplicantDetails]);

  const handleDecryptClick = async (value, requestor) => {
    try {
      const decrypt = await axios.post(url + "/borrower/decryptAadhaar", {
        email,
        token,
        id: value,
        requestor: requestor,
      });

      if (decrypt.data.auth === true) {
        toast.success("Decrypted");
        setInfoData(decrypt.data.message);
      } else {
        toast.error(decrypt.data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="min-h-screen bg-[#EDF5FF] flex">
      <Sidebar click={openView} />

      <div
        className={`flex-1 transition-all duration-300 ${isOpen ? "ml-56" : "ml-0"}`}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {/* MAIN CONTENT */}
        {/* <div className="px-10 py-10 mx-auto max-w-8xl"> */}
        <div className="px-10 py-10 mx-auto max-w-[90rem]">

          {/* BACK BUTTON */}
          {/* <div className="w-full max-w-[90rem] mt-20 flex items-center gap-2"> */}
          <div className="w-full max-w-8xl mx-auto mt-20 flex items-center gap-2">
            <ChevronLeftIcon className="w-5 h-5 text-blue-600" />
            <button
              onClick={() => navigate("/borrower/view")}
              className="text-blue-600 text-sm no-underline hover:no-underline"
            >
              Back to Borrowers
            </button>
          </div>

          {/* BORROWER HEADER CARD */}
          <div className="w-full  max-w-8xl mx-auto mt-4 bg-white rounded-xl shadow border border-gray-200 p-6 flex flex-col sm:flex-row items-center sm:items-start gap-6 mb-10">
            {ImageBase64 ? (
              <img
                src={ImageBase64}
                alt="Borrower"
                className="w-24 h-24 rounded-full shadow-sm object-cover border"
              />
            ) : (
              <div className="w-24 h-24 bg-gray-200 rounded-full flex items-center justify-center text-gray-500">
                No Image
              </div>
            )}

            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                {[borrower.borrower_firstname, borrower.borrower_middlename, borrower.borrower_lastname]
                  .filter(Boolean)
                  .join(" ")}
              </h2>

              <p className="text-sm text-gray-600 mt-1">
                Unique ID: {borrower.borrower_uniqueno || "N/A"}
                <span className="mx-2 text-gray-400">|</span>
                Created Date:{" "}
                {borrower.borrower_created_date
                  ? new Date(borrower.borrower_created_date).toLocaleDateString("en-GB")
                  : "N/A"}
              </p>
            </div>
          </div>

          {/* PROFILE + KYC GRID */}
          <div className="w-full  max-w-8xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">

            {/* Borrower Profile */}
            <div className="bg-white rounded-xl shadow border border-gray-200 p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-900">Borrower Profile</h3>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => navigate(`/view/personal/details/${borrower.borrower_uniqueno}`)}
                    className="text-blue-600 text-sm hover:underline"
                  >
                    View Details
                  </button>

                  {(EditButtonVisible || visible) && (
                    <FiEdit
                      className="text-gray-600 hover:text-gray-800 cursor-pointer"
                      title="Edit Personal Details"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/edit/borrower/screen/${borrower.borrower_uniqueno}`);
                      }}
                    />
                  )}
                </div>
              </div>

              <div className="space-y-2 text-sm text-gray-700">
                <p><span className="font-medium">Father's Name:</span> {borrower.borrower_fathername || "N/A"}</p>
                <p><span className="font-medium">Phone:</span> {borrower.borrower_mobile || "N/A"}</p>
                <p><span className="font-medium">Email:</span> {borrower.borrower_email || "N/A"}</p>
              </div>
            </div>

            {/* KYC */}

            <div className="bg-white rounded-xl shadow border border-gray-200 p-6 flex justify-between items-start">
              {/* LEFT SECTION */}
              <div className="space-y-2">
                {/* Title + Verified */}
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-lg font-semibold text-gray-900">
                    KYC Details
                  </h3>

                  <span className="text-xs bg-green-100 text-green-600 px-3 py-1 rounded-full font-medium">
                    Verified
                  </span>
                </div>

                {/* Aadhaar Row */}
                <div className="flex items-center gap-4">
                  <p className="text-sm">
                    Aadhaar Number:{" "}
                    <span className="font-medium">
                      {borrower.borrower_aadharno}
                    </span>
                  </p>

                  {(decryptButtonVisible || visible) && (
                    <button
                      className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-700 transition"
                      onClick={() =>
                        handleDecryptClick(
                          borrower.borrower_aadharno,
                          "kycBorrower"
                        )
                      }
                    >
                      Decrypt
                    </button>
                  )}
                </div>

                {/* Decrypted Aadhaar */}
                {infoData && (
                  <p className="text-sm text-green-700 font-semibold ml-1">
                    {infoData}
                  </p>
                )}

                {/* PAN */}
                <p className="text-sm">
                  PAN:{" "}
                  <span className="font-medium">
                    {borrower.borrower_panno}
                  </span>
                </p>

                {/* Age */}
                <p className="text-sm">
                  Age:{" "}
                  <span className="font-medium">
                    {borrower.borrower_age}
                  </span>
                </p>
              </div>

              {/* RIGHT SECTION */}
              {(AddDocVisible || ViewDocVisible || DownloadDocVisible || visible) && (
                <div>
                  <button
                    onClick={() =>
                      navigate(`/upload/kyc/docs/${borrower.borrower_uniqueno}`)
                    }
                    className="text-blue-600 text-sm hover:underline font-medium"
                  >
                    View Details
                  </button>
                </div>
              )}
            </div>

          </div>

          {/* LOANS SECTION */}
          <div className="w-full max-w-8xl mx-auto bg-white rounded-xl shadow border border-gray-200 p-6">

            <div className="flex justify-between items-center mb-5">
              <h3 className="text-lg font-semibold text-gray-900">
                Associated Loans ({loanData.length})
              </h3>

              {(AddLoanVisible || visible) && (
                <button
                  onClick={() => navigate("/add/new/loan")}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded-md"
                >
                  Add New Loan
                </button>
              )}
            </div>

            <div className="divide-y divide-gray-100">
              {loanData.map((loan, idx) => {
                const matchingCoapp = coapplicantDetails.filter(
                  (c) => c.coapplicant_loan_id === loan.loan_id
                );
                const names = matchingCoapp.map((c) => c.coapplicant_name);

                return (
                  <div key={idx} className="py-4 flex justify-between items-start">

                    {/* Left Side Loan Info */}
                    <div>
                      <p className="font-semibold text-gray-900">{loan.loan_id}</p>
                      <p className="text-sm text-gray-700">₹{loan.loan_principal_amt}</p>
                      <p className="text-sm text-gray-600">Loan Type: {loan.loan_type}</p>
                      <p className="text-sm text-gray-600">NBFC: {loan.nbfc_name}</p>
                      <p className="text-sm text-gray-600">LoanProduct: {loan.loanproduct_name}</p>

                      {names.length > 0 && (
                        <p className="text-sm text-gray-600">
                          Co-Applicants:{" "}
                          {names.map((n, i) => (
                            <span
                              key={i}
                              className="text-blue-600 hover:underline cursor-pointer mr-1"
                              onClick={() => navigate(`/borrower/detail/${loan.loan_id}`)}
                            >
                              {n}
                              {i < names.length - 1 && ","}
                            </span>
                          ))}
                        </p>
                      )}
                    </div>

                    {/* Right Side Status & Button */}
                    <div className="flex flex-col sm:flex-row sm:items-end gap-5">

                      <div>
                        <p className="text-xs text-gray-600 font-medium mb-1">Application Details</p>
                        <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full font-semibold">
                          {loan.application_status || "INCOMPLETE"}
                        </span>
                      </div>

                      <div>
                        <p className="text-xs text-gray-600 font-medium mb-1">Loan Status</p>
                        <span className="text-xs px-3 py-1 rounded-full font-semibold bg-blue-100 text-blue-600">
                          {loan.loan_status}
                        </span>
                      </div>

                      <button
                        onClick={() => navigate(`/borrower/detail/${loan.loan_id}`)}
                        className="bg-blue-600 hover:bg-blue-700 text-white text-xs px-3 py-1 rounded-md"
                      >
                        View Details
                      </button>

                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default BorrowerDetailsScreen;

